import DoneIcon from '@mui/icons-material/Done';
import { Avatar, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import { WarningAmber } from '@mui/icons-material';
type Props = {
  message: string;
  isError?: boolean;
  isWarning?: boolean;
};

const styles = {
  parentBox: {
    // boxShadow: '0px 5px 22px 0px rgba(0, 0, 0, 0.08)',
    boxShadow: '0px 0px 22px rgba(0, 0, 0, 0.1)',
    background: '#FFFFFF',
    width: '450px',
    height: '148px',
    position: 'fixed',
    bottom: 50,
    right: 48,
  },
};

const ErrorIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="20"
        fill="#F04438"
      />
      <path
        d="M20 14.49L27.53 27.5H12.47L20 14.49ZM20 10.5L9 29.5H31L20 10.5Z"
        fill="#F0FDF9"
      />
      <path
        d="M21 24.5H19V26.5H21V24.5Z"
        fill="#F0FDF9"
      />
      <path
        d="M21 18.5H19V23.5H21V18.5Z"
        fill="#F0FDF9"
      />
    </svg>
  );
};

const SimpleSnackbar = (props: Props) => {
  const { message, isError, isWarning } = props;

  return (
    <>
      <Box sx={styles.parentBox}>
        <Grid
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'column'}
          gap={'10px'}
          padding={'24px'}
          height={'100%'}
        >
          {isWarning ? (
            <>
              <Grid
                container
                alignItems="center"
                justifyContent={'center'}
                sx={{
                  width: '70px',
                  height: '70px',
                  borderRadius: '50%',
                  background: 'rgba(247, 144, 9, 0.12)',
                  color: '#B54708',
                }}
              >
                <WarningAmber sx={{ height: '30px', width: '30px' }} />
              </Grid>
            </>
          ) : isError ? (
            <ErrorIcon />
          ) : (
            <Avatar sx={{ background: '#15B79E' }}>
              <DoneIcon sx={{ color: 'white' }} />
            </Avatar>
          )}

          <Typography
            sx={{
              textAlign: 'center',
              height: 100,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            variant="h6"
          >
            {message}
          </Typography>
        </Grid>
      </Box>
    </>
  );
};
export default SimpleSnackbar;
